// tslint:disable:max-line-length

import React from 'react';

export const ActionPin = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M5,0C4.7,0,4.5,0.2,4.5,0.5S4.7,1,5,1h0.5v3.8C5.5,5.5,5,6,4.3,6H3.7C3,6,2.5,6.5,2.5,7.2V9l4.7,0v5L8,16l0.8-2V9h4.7V7.2 C13.5,6.5,13,6,12.3,6h-0.7c-0.6,0-1.2-0.5-1.2-1.2V1H11c0.3,0,0.5-0.2,0.5-0.5S11.3,0,11,0C11,0,5,0,5,0z" />
    </svg>
  );
};
